import React from 'react';
import { planDeliveryContainerStyle } from '../AirtimePlanningStyles';
import DeliveryImpacts from './DeliveryImpacts';
import DeliverySpots from './DeliverySpots';

const PlanDelivery = ({
    hasPlan,
    planSummary,
    showImpacts,
    showBaseImpacts,
    setTotalAirtimeCost
}) => {
    return (
        <div style={planDeliveryContainerStyle}>
            <DeliverySpots hasPlan={hasPlan} planSummary={planSummary} />

            <DeliveryImpacts
                hasPlan={hasPlan}
                planSummary={planSummary}
                showImpacts={showImpacts}
                showBaseImpacts={showBaseImpacts}
                setTotalAirtimeCost={setTotalAirtimeCost}
            />
        </div>
    );
};

export default PlanDelivery;
